import { ListItem, ListItemButton } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { SearchResultResponse } from '../../api/CoreSearchApi';
import {
	UI_CASH_MANAGEMENT_FEATURE_ENABLED,
	useAuthContext,
} from '../../context/auth';
import SearchCard from '../coreSearch/SearchCard';
import { SEARCH_BOX__SEARCH_RESULT_HEIGHT } from './styles';
import { getSearchResultData } from './util';

interface Props {
	searchResult: SearchResultResponse;
	index: number;
	afterListClick?: () => void;
}
export default function CoreSearchResultListItem(props: Props) {
	const { searchResult, index, afterListClick } = props;
	const authData = useAuthContext();
	const searchCardProps = getSearchResultData(
		searchResult,
		authData?.auth?.configProperties?.[UI_CASH_MANAGEMENT_FEATURE_ENABLED],
	);
	if (!searchCardProps) {
		return null;
	}

	return (
		<React.Fragment key={index}>
			<ListItem disableGutters disablePadding>
				<ListItemButton
					component={Link}
					to={searchCardProps?.value}
					sx={{ height: SEARCH_BOX__SEARCH_RESULT_HEIGHT }}
					id={`Search__SearchResult-${index}`}
					onClick={afterListClick}
				>
					<SearchCard {...searchCardProps} />
				</ListItemButton>
			</ListItem>
		</React.Fragment>
	);
}
